import { render } from "./GPUSummaryTab.vue?vue&type=template&id=0c863dae&scoped=true"
import script from "./GPUSummaryTab.vue?vue&type=script&lang=js"
export * from "./GPUSummaryTab.vue?vue&type=script&lang=js"

import "./GPUSummaryTab.vue?vue&type=style&index=0&id=0c863dae&scoped=true&lang=css"

import exportComponent from "/opt/novus-cloud-ui/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c863dae"]])

export default __exports__